import { sortDates, isWeekendDay } from '../dates.js';
/**
 * Check if a list of dates is taking place across multiple week-numbers.
 *
 * @returns `true` if the array of dates spans multiple weeks.
 */
export const datesSpanMultipleWeeks = (dates) => {
    const uniqueWeeks = new Set(sortDates(dates).map((dt) => dt.weekNumber));
    return uniqueWeeks.size > 1;
};
/**
 * Function to check if the conversation dates that are provided are valid versus each other.
 *
 * @returns `true` when conversation dates are valid
 */
export const validateConversationDates = (conversationDates, optInClosesAt) => {
    if (!conversationDates?.length) {
        return true;
    } // prettier-ignore
    return conversationDates.every((date, index) => {
        return (
        // [CONSTRAINT] conversationDates must be in the same week
        index === 0 ? true : date.weekNumber === conversationDates[index - 1].weekNumber,
            // [CONSTRAINT] conversationDates must be at least 24 hours later than optInClosesAt date
            // [CONSTRAINT] conversationDates must not be in the weekend
            optInClosesAt.plus({ days: 1 }) <= date && !isWeekendDay(date));
    });
};
/**
 * Checks if all dates are unique or if two or more dates share the same day.
 *
 * @returns `true` when all dates are on unique days
 */
export const datesAreUniqueDays = (dates) => {
    if (!dates?.length) {
        return true;
    }
    const datesSet = dates.reduce((set, date) => set.add(date.day), new Set());
    return datesSet.size === dates.length;
};
/**
 * Check if any combination of dates are within 1 hour of each other. NOTE: This function does take
 * into account the timezone by the sorting with milliseconds.
 *
 * @param dates - list of dates
 * @param hoursThreshold - number indicating the threshold
 *
 * @returns `true` when all days are at least X hours apart.
 */
export const datesAreMinimumHoursApart = (dates, hoursThreshold = 1) => {
    if (!dates?.length) {
        return true;
    }
    const sortedDates = sortDates(dates);
    return sortedDates.every((dt, index) => {
        return !index ? true : dt >= dates[index - 1].plus({ hours: hoursThreshold });
    });
};
